(() => {
  const ROOT_SELECTOR = '[data-glt-landing]';

  function initLanding(root) {
    if (!root || root.dataset.gltReady === 'true') return;
    root.dataset.gltReady = 'true';

    const nav = root.querySelector('[data-glt-nav]');
    const mobileMenu = root.querySelector('[data-glt-mobile-menu]');
    const openButton = root.querySelector('[data-glt-menu-open]');
    const closeButton = root.querySelector('[data-glt-menu-close]');
    const toast = root.querySelector('[data-glt-toast]');
    let toastTimer;

    const setScrolled = () => {
      if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });

    const setMenu = (open) => {
      if (!mobileMenu) return;
      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.setAttribute('aria-hidden', String(!open));
      if (openButton) openButton.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      document.body.style.overflow = open ? 'hidden' : '';
    };

    openButton?.addEventListener('click', () => setMenu(true));
    closeButton?.addEventListener('click', () => setMenu(false));
    mobileMenu?.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', () => setMenu(false));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileMenu?.classList.contains('is-open')) setMenu(false);
    });

    root.querySelectorAll('a[href^="#glt-"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', link.getAttribute('href'));
      });
    });

    const revealItems = root.querySelectorAll('.glt-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -70px 0px', threshold: 0.02 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    const showToast = (message, error = false) => {
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.textContent = message;
      toast.classList.toggle('is-error', error);
      toast.classList.add('is-visible');
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3200);
    };

    const addToCart = async (button) => {
      const variantId = Number(button.dataset.variantId);
      if (!variantId) {
        showToast('Please select the Glutathione product in the Theme Editor.', true);
        return;
      }

      // Open the new tab synchronously from the user's click. If this is done
      // after awaiting Shopify's cart request, browsers can treat it as a popup.
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      const cartTab = window.open('', '_blank');

      if (cartTab) {
        try {
          cartTab.document.title = 'Opening your Glutagem cart…';
          cartTab.document.body.innerHTML = '<p style="font-family:Arial,sans-serif;padding:32px">Adding your item to the cart…</p>';
        } catch (e) {
          // Harmless: some browser privacy settings prevent writing to about:blank.
        }
      }

      const allButtons = root.querySelectorAll('[data-glt-add]');
      allButtons.forEach((btn) => {
        btn.classList.add('is-loading');
        btn.disabled = true;
      });

      try {
        const endpoint = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this item to the cart.');
        }

        setMenu(false);

        if (cartTab && !cartTab.closed) {
          cartTab.location.replace(cartUrl);
          showToast('Added to your cart — opened in a new tab.');
        } else {
          // Popup blocking is uncommon because the tab is opened directly by the
          // click, but preserve a useful fallback if the browser still blocks it.
          showToast('Added to your cart. Your browser blocked the new cart tab.', true);
        }
      } catch (error) {
        if (cartTab && !cartTab.closed) cartTab.close();
        showToast(error.message || 'Unable to add this item to the cart.', true);
      } finally {
        allButtons.forEach((btn) => {
          btn.classList.remove('is-loading');
          if (btn.dataset.variantId) btn.disabled = false;
        });
      }
    };

    root.querySelectorAll('[data-glt-add]').forEach((button) => {
      button.addEventListener('click', () => addToCart(button));
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initLanding);
    if (scope.matches?.(ROOT_SELECTOR)) initLanding(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  });
})();
